import { CheckSolid, PenSolid, TrashCanSolid, XmarkSolid } from '@allocab/allocab-icons';
import clsx from 'clsx';
import { ChangeEvent, useState } from 'react';

import { AlertDialog } from '../../components/dialog/AlertDialog';
import { Spinner } from '../../components/Spinner';
import { t } from '../../services/translation/translation';

type Props = {
  receptionist: string;
  even: boolean;
  isDeleting: boolean;
  isUpdating: boolean;
  onDelete: (_receptionist: string) => void;
  onUpdate: (_receptionist: string, _newValue: string) => void;
};

export const ReceptionistListItem = ({ receptionist, even, isDeleting, isUpdating, onDelete, onUpdate }: Props) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showEditInput, setShowEditInput] = useState(false);
  const [value, setValue] = useState(receptionist);

  const handleDelete = () => {
    setShowDeleteDialog(false);
    onDelete(receptionist);
  };

  const handleUpdate = () => {
    onUpdate(receptionist, value);
    setShowEditInput(false);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <div
      key={receptionist}
      className={clsx(even ? '' : 'bg-background_highlight', 'px-4 h-12 flex items-center justify-between gap-x-2')}
    >
      <div className="flex items-center gap-x-2">
        {showEditInput ? (
          <>
            <input
              type="text"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="Pam Beesly"
              value={value}
              onChange={handleChange}
            />
            <button type="button" onClick={handleUpdate}>
              <CheckSolid className="fill-cta" width={16} height={16} />
            </button>
          </>
        ) : (
          <p className="capitalize flex-1">{receptionist.toLocaleLowerCase()}</p>
        )}
        <button type="button" onClick={() => setShowEditInput(v => !v)}>
          {isUpdating ? (
            <Spinner />
          ) : showEditInput ? (
            <XmarkSolid className="fill-cta" width={16} height={16} />
          ) : (
            <PenSolid className="fill-cta" width={16} height={16} />
          )}
        </button>
      </div>
      <button type="button" onClick={() => setShowDeleteDialog(true)}>
        {isDeleting ? <Spinner /> : <TrashCanSolid className="fill-error" width={16} height={16} />}
      </button>
      {showDeleteDialog ? (
        <AlertDialog
          isOpen
          onClose={() => setShowDeleteDialog(false)}
          confirmLabel={t('common.delete')}
          onConfirm={handleDelete}
          title={t('receptionists-route.delete.title', { name: receptionist })}
          message={t('receptionists-route.delete.message')}
        />
      ) : null}
    </div>
  );
};
